<script>
    export default {
        props: {
            course: Object,
            interval: {
                type: String,
                default: 'hours'
            },
            countdown: {
                type: Number,
                default: 48
            }
        },
        data() {
            return {
                storageDate: null,
                date: moment(this.course.updated_at).add(this.countdown, this.interval),
                now: Math.trunc(moment().valueOf() / 1000),
            }
        },
        computed: {
            dateInMilliseconds() {
                return Math.trunc(this.date.valueOf() / 1000)
            },
            seconds() {
                return (this.dateInMilliseconds - this.now) % 60;
            },
            minutes() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
            },
            hours() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60);
            },
        },
        mounted() {
            let courseDate = moment(this.course.updated_at).add(48, 'hours');
            let now = moment();
            while((courseDate.isBefore(now))) {
                courseDate = courseDate.add(48, 'hours');
            }
            this.$set(this, 'date', moment(courseDate));
            //this.form.promotion_id = this.promotions[0].id;

            let vm = this;
            window.setInterval(() => {
                vm.now = Math.trunc(moment().valueOf() / 1000);
            }, 1000);
            /*
            let courseDate = moment(this.course.updated_at).add(this.countdown, this.interval).valueOf() / 1000;
            if ((courseDate - this.now) <= 0) {
                if (!window.localStorage.getItem(`date_${this.course.id}`)) {
                    window.localStorage.setItem(`date_${this.course.id}`, moment())
                }
                this.storageDate = window.localStorage.getItem(`date_${this.course.id}`)
                this.$set(this, 'date', moment(this.storageDate).add(this.countdown, this.interval))
            } else {
                this.$set(this, 'date', moment(this.course.updated_at).add(this.countdown, this.interval))
            }

            let vm = this
            window.setInterval(() => {
                if ((vm.dateInMilliseconds - vm.now) <= 0) {
                    window.localStorage.setItem(`date_${this.course.id}`, moment())
                    vm.storageDate = window.localStorage.getItem(`date_${this.course.id}`)
                    vm.$set(vm, 'date', moment(vm.storageDate).add(vm.countdown, vm.interval))
                }
                vm.now = Math.trunc(moment().valueOf() / 1000);
            }, 1000);*/
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/InvitationCountdown.vue